// extracted by mini-css-extract-plugin
module.exports = {"path":"map_path__3kBoU"};